var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"home"},[_c('campaign')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }